export const REQUIREMENT__SET_ALL = 'REQUIREMENT__SET_ALL';
export const STEPS__SET_ALL = 'STEPS__SET_ALL';
export const IS_EDITABLE__UPDATE = 'IS_EDITABLE__UPDATE';
